module.exports = __webpack_public_path__ + "static/media/ultragaz-logo-white.94cd7712.svg";